// Profile photos: when a member has no photo (or it fails to load) show the standard default.
export const DEFAULT_AVATAR = 'https://emiratesscholar.com/system/public/default.jpg';

// An old system placeholder some accounts still carry; treat it as "no photo".
const LEGACY_PLACEHOLDER = 'https://citescholar.com/portal/public/documents/snvTh447dbBADFho2rOueBMotBaLnHBccvRDdaBI.png';

export const hasRealAvatar = (url) => {
  const u = String(url || '').trim();
  return u !== '' && u !== LEGACY_PLACEHOLDER;
};

/** The member's photo URL, or the default photo. */
export const avatarOrDefault = (url) => (hasRealAvatar(url) ? String(url).trim() : DEFAULT_AVATAR);

/**
 * CSS background-image value: the photo layered over the default, so a missing or broken
 * photo still shows the default underneath.
 */
export const avatarBackground = (url) =>
  hasRealAvatar(url) ? `url("${String(url).trim()}"), url("${DEFAULT_AVATAR}")` : `url("${DEFAULT_AVATAR}")`;

/** <img onError>: swap a broken photo for the default (once, so it can't loop). */
export const showDefaultAvatarOnError = (e) => {
  if (e.currentTarget.src !== DEFAULT_AVATAR) {
    e.currentTarget.src = DEFAULT_AVATAR;
  }
};
